module.exports = __webpack_public_path__ + "files/b2847830e341fdab29b4dd916cb595a0.png";